import {
  getRequestCorrelation,
  getSessionCorrelation,
  getSharedHeaders,
} from './';

export const getClientRequestHeaders = sessionId => {
  const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : '';

  return {
    ...getSharedHeaders(),
    ...getSessionCorrelation(sessionId),
    ...getRequestCorrelation(),
    Accept: 'application/json',
    'cache-control': 'no-cache',
    Pragma: 'no-cache',
    'ui-request-timestamp': new Date().toISOString(),
    'x-csrf-token': csrfToken,
    ...(__BRAND__
      ? {
          'x-hsbc-brand': __BRAND__,
        }
      : {}),
  };
};
